import React from 'react';
import { motion } from 'framer-motion';
const steps = [{
  number: '01',
  title: 'Arrival',
  desc: 'Arrive at our private LA location. You will be greeted with a warm towel, a soothing beverage, and absolute privacy.'
}, {
  number: '02',
  title: 'Soak & Cleanse',
  desc: 'Begin your journey in the jacuzzi hot tub or under our rainfall shower. Surrender the day in our immaculate bathroom.'
}, {
  number: '03',
  title: 'The Experience',
  desc: 'Move to one of our two private suites. Your practitioner will guide you through your chosen sensual journey.'
}];
export function Ritual() {
  return <section className="py-24 md:py-32 relative" data-id="element-304">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-305">
        <div className="text-center mb-20" data-id="element-306">
          <span className="text-rose-400 uppercase tracking-[0.2em] text-sm mb-4 block" data-id="element-307">
            Your Visit
          </span>
          <h2 className="font-serif text-4xl md:text-5xl text-lavender-50 mb-4" data-id="element-308">
            The{' '}
            <span className="italic bg-gradient-to-r from-lavender-300 to-rose-400 bg-clip-text text-transparent" data-id="element-309">
              Ritual
            </span>
          </h2>
          <p className="text-lavender-100/60 font-light" data-id="element-310">
            A glimpse into what awaits you at Afriel.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-6" data-id="element-311">
          {steps.map((step, index) => <motion.div key={step.number} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.15,
          duration: 0.6
        }} className="relative p-6 rounded-2xl bg-plum-900/30 border border-lavender-400/10 hover:border-lavender-400/30 transition-colors" data-id="element-312">
              <div className="font-serif text-6xl bg-gradient-to-br from-lavender-300 to-rose-400 bg-clip-text text-transparent mb-4 leading-none" data-id="element-313">
                {step.number}
              </div>
              <h3 className="font-serif text-2xl text-lavender-50 mb-3" data-id="element-314">
                {step.title}
              </h3>
              <p className="text-lavender-100/70 font-light leading-relaxed text-sm" data-id="element-315">
                {step.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}